import { Component } from '@angular/core';
import { OrderSummaryPageComponent } from 'libs/shared/src/lib/page/order-summary/order-summary.component';

@Component({ standalone: false, selector: 'app-page-order-summary', templateUrl: './order-summary.component.html' })
export class CustomOrderSummaryPageComponent extends OrderSummaryPageComponent {}
